import { fetchApi } from "./api"
import { normalizeAlfredGlobalConfig } from "./alfred-normalize"
import { mockAlfredService } from "@/mocks/mock-service"
import type { AlfredGlobalConfig, UpdateAlfredGlobalConfigRequest } from "@/types/alfred-config"

const USE_MOCKS = import.meta.env.VITE_USE_MOCKS === "true"

const ALFRED_GLOBAL_PATH = "/api/v1/config/alfred/global"

const realAlfredService = {
  async getGlobal(): Promise<AlfredGlobalConfig> {
    const config = await fetchApi<AlfredGlobalConfig>(ALFRED_GLOBAL_PATH)
    return normalizeAlfredGlobalConfig(config)
  },

  async updateGlobal(data: UpdateAlfredGlobalConfigRequest): Promise<AlfredGlobalConfig> {
    const config = await fetchApi<AlfredGlobalConfig>(ALFRED_GLOBAL_PATH, {
      method: "PUT",
      body: JSON.stringify(data),
    })
    return normalizeAlfredGlobalConfig(config)
  },
}

export const alfredService = USE_MOCKS ? mockAlfredService : realAlfredService

if (import.meta.env.DEV) {
  console.log(`🔧 Alfred Service: ${USE_MOCKS ? "MOCK MODE" : "API MODE"}`)
}
